<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>建议反馈</h2>
					<div class="help-cont">
						<div class="alert alert-warning">
							<p class="h5">
								如果您在使用本平台过程中遇到问题Bug，或者有更好的意见建议，欢迎留言，感谢您对{{$namePc}}的支持；
								<br />
								此反馈不会马上回复，如果您遇到卡券处理问题，请联系右下角在线客服，以免耽误您的卡券处理进度。
							</p>

						</div>
						<div class="form-group">
							<div class="col-xs-1">
								<label class="control-label">联系方式</label>
							</div>
							<div class="col-xs-4">
								<input class="form-control" v-model="phone" placeholder="请输入手机号或QQ号" />
							</div>
						</div>
						<div class="form-group">
							<div class="col-xs-1">
								<label class="control-label">反馈内容</label>
							</div>
							<div class="col-xs-10">
								<textarea class="form-control py10" v-model="content" placeholder="请详细描述您的问题或建议（必填）" ></textarea>
							</div>
						</div>
						<div class="form-group">
							<div class="col-xs-3 col-xs-offset-1">
								<button class="btn btn-green btn-lg btn-block" type="button" @click="getOpinion">提交反馈</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftAbout from '../common/about/index.vue'
	import config from "../../config";
	export default{
		name:"Opinion",
		data(){
			return{
				baseUrl:"",
				token:"",
				imgList:[],
				dialogImageUrl:"",
				dialogVisible:false,
				phone:"",
				content:""
			}
		},
		created() {
			this.baseUrl = config.apiUrl;
			this.token = localStorage.getItem('token')
		},
		components:{
			leftAbout
		},
		methods:{
			getOpinion(){
				if(!this.phone){
					this.$message({
						message: '请输入手机号',
						type: 'warning'
					});
					return
				}
				if(!this.content){
					this.$message({
						message: '请输入内容',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.submitFeedback({
					phone: this.phone,
					content: this.content,
					images:"",
					token: token,
				}).then(res => {
					if(res.code === 1){

					}else{

					}
				})
			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/opinion.vue